'use client'
import { useIndustriesNavbarScroll } from '@/Hooks'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import FintechSectionThree from './components/FintechSectionThree'
import FiFromStrategy from './components/FiFromStrategy'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'
import CuttingEdge from './components/CuttingEdge'
import EducationWhyChoose from './components/EducationWhyChoose'

const educationFaqData = [
   {
      question:
         'What is education software development, and how can it benefit my institution?',
      answer:
         'It means building tools like online learning systems, virtual classrooms, or admin portals that help teachers teach, cut down the paperwork, and keep students more involved.',
   },
   {
      question: 'What types of education software does Benzatine develop?',
      answer:
         'We design e-learning platforms, Learning Management Systems (LMS), Artificial Intelligence-based EdTech solutions, online exam software, school management systems, and mobile learning apps.',
   },
   {
      question:
         'How do your education software solutions improve learning outcomes?',
      answer:
         'Our software uses AI-based personalization, gamification, interactive learning materials, and live performance monitoring to increase student participation and retention.',
   },
   {
      question:
         'Can you integrate AI and machine learning into education software?',
      answer:
         'Yes, we create AI-fueled functionality such as adaptable learning pathways, predictive analysis, automated tutoring, and intelligent evaluations to provide custom learning experiences.',
   },
   {
      question:
         'Is your education software compliant with data security regulations?',
      answer:
         'Indeed! We are GDPR, FERPA, and other education data security compliance standards, with encryption, access control, and secure cloud storage.',
   },
   {
      question: 'Do you provide mobile learning (mLearning) solutions?',
      answer:
         'Yes, we create mobile-enabled e-learning applications with offline capability, push notifications, progress tracking, and AI-driven course recommendations.',
   },
   {
      question:
         'How does your LMS development enhance online learning experiences?',
      answer:
         'Our LMS products provide drag-and-drop course development, multi-media content authoring, automatic grading, integration with live video streaming, and progress tracking by analytics.',
   },
   {
      question:
         'Is it possible to integrate your software with current school management systems?',
      answer:
         'Yes, we can hook it into what you’re already using — whether that’s your LMS, student info system, or other tools. That way, everything keeps working together and you’re not wasting time redoing stuff that already does the job.',
   },
   {
      question:
         'How long does it take to develop a custom education software solution?',
      answer:
         'That really depends on what the project needs. For most education software, you’re usually looking at around three to six months to get it built and running.',
   },
   {
      question:
         'How can I get started with Benzatine’s education software development services?',
      answer:
         'Just reach out and we’ll take it from there. We’ll talk through what you’re trying to build, suggest the right tools for it, and help you shape a platform that actually fits your goals.',
   },
];

function EducationPage() {
   useIndustriesNavbarScroll()

   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />
         <FintechSectionThree />
         <FiFromStrategy />

         <CuttingEdge />

         <EducationWhyChoose />
         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>
         <FAQs faqsConst={educationFaqData} />

         <ContactUsForm />
      </>
   )
}

export default EducationPage
